(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["product-card"] && !Shopify.designMode) return;
  try {
    (() => {
const patterns={earrings:/\b(?:earrings?|ear rings?|hoops?|studs?)\b|küpe/iu,bracelet:/\b(?:bracelets?|bangles?)\b|bileklik/iu,necklace:/\b(?:necklaces?|pendants?|chokers?)\b|kolye/iu,ring:/\b(?:rings?)\b|yüzük/iu,anklet:/\b(?:anklets?)\b|halhal/iu};
const requests=new Map();
const processed=new WeakSet();
async function load(category){
 const found=new Map();
 for(let page=1;page<=4&&found.size<50;page++){
  const params=new URLSearchParams({shop_domain:window.jdgm?.SHOP_DOMAIN||window.Shopify?.shop||document.domain,platform:window.jdgmSettings?.platform||'shopify',widget_type:'all-reviews-widget-v2025',page:String(page),per_page:'50',review_type:'shop-reviews',sort_by:'created_at',sort_dir:'desc',search:category});
  const host=(window.jdgm?.CDN_API_HOST||'https://cdn.judge.me/').replace(/\/$/,'');
  const cacheKey='bluvvy-review-page-v1:'+params.toString();let cached=null;try{const item=JSON.parse(sessionStorage.getItem(cacheKey)||'null');if(item&&Date.now()-item.time<300000)cached=item.data;}catch{}
  const response=cached?null:await fetch(`${host}/reviews/all_reviews_js_based?${params}`,{credentials:'omit',headers:{Accept:'application/json'}});
  if(response&&!response.ok)throw new Error('Review request failed');
  const data=cached||await response.json();if(!cached){try{sessionStorage.setItem(cacheKey,JSON.stringify({time:Date.now(),data}));}catch{}}const reviews=data.reviews||data.shop_reviews||data.all_reviews||[];
  if(!reviews.length)break;
  for(const r of reviews){
   const body=String(r.body||'').trim();const rating=Number(r.rating);
   if(!body||rating<1||rating>5||!patterns[category].test(body))continue;
   if(category==='ring'&&/\bear rings?\b|\b(?:necklaces?|pendants?|bracelets?|bangles?|anklets?|jump rings?|key rings?)\b/iu.test(body))continue;
   const id=r.uuid||`${r.reviewer_name||'customer'}-${r.created_at||''}`;
   if(!found.has(id)&&found.size<50)found.set(id,rating);
  }
 }
 return {count:found.size,rating:found.size?[...found.values()].reduce((a,b)=>a+b,0)/found.size:0};
}
function scan(){
 document.querySelectorAll('product-card[data-review-context]').forEach(card=>{
  const badge=card.querySelector('.jdgm-prev-badge');
  if(!badge||processed.has(badge))return;
  const category=Object.keys(patterns).find(k=>patterns[k].test(card.dataset.reviewContext));
  if(!category)return;
  processed.add(badge);
  if(!requests.has(category))requests.set(category,load(category));
  requests.get(category).then(({count,rating})=>{
   if(!count||!badge.isConnected)return;
   const link=document.createElement('a');link.className='bluvvy-card-rating';
   const destination=card.querySelector('.product-card__link');
   link.href=(destination?.href||'').split('#')[0]+'#bluvvy-product-reviews';
   link.title=`${category} collection reviews`;
   link.setAttribute('aria-label',`${rating.toFixed(1)} out of 5, ${count} ${category} collection reviews`);
   const stars=document.createElement('span');stars.className='bluvvy-card-stars';stars.setAttribute('aria-hidden','true');stars.textContent='★★★★★';
   const fill=document.createElement('span');fill.textContent='★★★★★';stars.style.setProperty('--rating-fill',`${rating/5*100}%`);stars.append(fill);
   const number=document.createElement('span');number.textContent=`${rating.toFixed(1)} - ${count}`;
   link.append(stars,number);badge.after(link);badge.classList.add('bluvvy-rating-replaced');
  }).catch(()=>{});
 });
}
let scheduled=false;
new MutationObserver(()=>{if(!scheduled){scheduled=true;requestAnimationFrame(()=>{scheduled=false;scan();});}}).observe(document.documentElement,{childList:true,subtree:true});
scan();
})();
  } catch(e) { console.error(e); }
})();

})();
